import { useEffect } from "react";
import Header from "../components/header";
import TopBanner from "../components/blocks/topBanner";
import TextBlock from "../components/blocks/textBlock";
import TabsBlock from "../components/blocks/tabsBlock";
import NewsBlock from "../components/blocks/newsBlock";
import PartnersBlock from "../components/blocks/partnersBlock";
import Footer from "../components/footer";
import { useSectionRegister } from "../components/contexts/SectionContext";

export default function Home() {
  useEffect(() => {
    // Прокрутка вверх + небольшой таймаут для гарантии
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant", // Мгновенная прокрутка
      });
    }, 0);
  }, []);
  const homeRef = useSectionRegister("home");
  const ecosystemRef = useSectionRegister("ecosystem");
  const pressRef = useSectionRegister("press");

  return (
    <div className="Home">
      <div ref={homeRef}></div> {/* Пустой div для секции home */}
      <Header />
      <TopBanner />
      <TextBlock />
      <section ref={ecosystemRef} id="ecosystem">
        <TabsBlock />
      </section>
      <section ref={pressRef} id="press">
        <NewsBlock />
      </section>
      <PartnersBlock />
      <Footer />
    </div>
  );
}
